import { render, staticRenderFns } from "./Ernaehrungsplaene.vue?vue&type=template&id=039cc005&"
import script from "./Ernaehrungsplaene.vue?vue&type=script&lang=js&"
export * from "./Ernaehrungsplaene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports